package flagpack.icons.small

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Equatorial Guinea Flag (16x12dp)
 *
 * - ISO Alpha-2: GQ
 * - ISO Alpha-3: GNQ
 * - ISO Numeric: 226
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Small.EquatorialGuinea: ImageVector by lazy {
    ImageVector.Builder(
        name = "Equatorial Guinea:GQ:GNQ:226:Small",
        defaultWidth = 16.dp,
        defaultHeight = 12.dp,
        viewportWidth = 16f,
        viewportHeight = 12f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(12.288f)
                horizontalLineTo(16.384f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(12.288f)
                horizontalLineTo(16.384f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFF009D00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(4.096f)
                horizontalLineTo(16.384f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 4.096f)
                verticalLineTo(8.192f)
                horizontalLineTo(16.384f)
                verticalLineTo(4.096f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF80000)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 8.192f)
                verticalLineTo(12.288f)
                horizontalLineTo(16.384f)
                verticalLineTo(8.192f)
                horizontalLineTo(0f)
                close()
            }
        }
        path(
            fill = SolidColor(Color(0xFF0075D5)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(0f, 0f)
            verticalLineTo(12.288f)
            lineTo(4.096f, 6.222f)
            lineTo(0f, 0f)
            close()
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(12.288f)
                lineTo(4.096f, 6.222f)
                lineTo(0f, 0f)
                close()
            }
        ) {
        }
        path(
            fill = SolidColor(Color(0xFFFFD500)),
            stroke = SolidColor(Color.Black),
            strokeLineWidth = 0.03f
        ) {
            moveTo(7.46f, 4.55f)
            lineTo(7.463f, 4.561f)
            lineTo(7.447f, 4.547f)
            lineTo(7.344f, 4.452f)
            lineTo(7.332f, 4.591f)
            lineTo(7.343f, 4.592f)
            lineTo(7.324f, 4.603f)
            lineTo(7.202f, 4.671f)
            lineTo(7.33f, 4.726f)
            lineTo(7.335f, 4.715f)
            lineTo(7.339f, 4.737f)
            lineTo(7.367f, 4.874f)
            lineTo(7.459f, 4.769f)
            lineTo(7.45f, 4.761f)
            lineTo(7.472f, 4.764f)
            lineTo(7.61f, 4.78f)
            lineTo(7.539f, 4.66f)
            lineTo(7.529f, 4.666f)
            lineTo(7.538f, 4.646f)
            lineTo(7.597f, 4.519f)
            lineTo(7.46f, 4.55f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFFFD500)),
            stroke = SolidColor(Color.Black),
            strokeLineWidth = 0.03f
        ) {
            moveTo(7.972f, 4.55f)
            lineTo(7.975f, 4.561f)
            lineTo(7.959f, 4.547f)
            lineTo(7.856f, 4.452f)
            lineTo(7.844f, 4.591f)
            lineTo(7.855f, 4.592f)
            lineTo(7.836f, 4.603f)
            lineTo(7.714f, 4.671f)
            lineTo(7.842f, 4.726f)
            lineTo(7.847f, 4.715f)
            lineTo(7.851f, 4.737f)
            lineTo(7.878f, 4.874f)
            lineTo(7.971f, 4.769f)
            lineTo(7.962f, 4.761f)
            lineTo(7.984f, 4.764f)
            lineTo(8.122f, 4.78f)
            lineTo(8.051f, 4.66f)
            lineTo(8.041f, 4.666f)
            lineTo(8.05f, 4.646f)
            lineTo(8.109f, 4.519f)
            lineTo(7.972f, 4.55f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFFFD500)),
            stroke = SolidColor(Color.Black),
            strokeLineWidth = 0.03f
        ) {
            moveTo(8.484f, 4.55f)
            lineTo(8.487f, 4.561f)
            lineTo(8.471f, 4.547f)
            lineTo(8.368f, 4.452f)
            lineTo(8.356f, 4.591f)
            lineTo(8.367f, 4.592f)
            lineTo(8.348f, 4.603f)
            lineTo(8.226f, 4.671f)
            lineTo(8.355f, 4.726f)
            lineTo(8.359f, 4.715f)
            lineTo(8.363f, 4.737f)
            lineTo(8.391f, 4.874f)
            lineTo(8.483f, 4.769f)
            lineTo(8.474f, 4.761f)
            lineTo(8.496f, 4.764f)
            lineTo(8.634f, 4.78f)
            lineTo(8.563f, 4.66f)
            lineTo(8.553f, 4.666f)
            lineTo(8.562f, 4.646f)
            lineTo(8.621f, 4.519f)
            lineTo(8.484f, 4.55f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFFFD500)),
            stroke = SolidColor(Color.Black),
            strokeLineWidth = 0.03f
        ) {
            moveTo(8.996f, 4.55f)
            lineTo(8.999f, 4.561f)
            lineTo(8.983f, 4.547f)
            lineTo(8.88f, 4.452f)
            lineTo(8.868f, 4.591f)
            lineTo(8.879f, 4.592f)
            lineTo(8.86f, 4.603f)
            lineTo(8.738f, 4.671f)
            lineTo(8.866f, 4.726f)
            lineTo(8.871f, 4.715f)
            lineTo(8.875f, 4.737f)
            lineTo(8.903f, 4.874f)
            lineTo(8.995f, 4.769f)
            lineTo(8.986f, 4.761f)
            lineTo(9.008f, 4.764f)
            lineTo(9.146f, 4.78f)
            lineTo(9.075f, 4.66f)
            lineTo(9.065f, 4.666f)
            lineTo(9.074f, 4.646f)
            lineTo(9.133f, 4.519f)
            lineTo(8.996f, 4.55f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFFFD500)),
            stroke = SolidColor(Color.Black),
            strokeLineWidth = 0.03f
        ) {
            moveTo(9.508f, 4.55f)
            lineTo(9.511f, 4.561f)
            lineTo(9.495f, 4.547f)
            lineTo(9.392f, 4.452f)
            lineTo(9.38f, 4.591f)
            lineTo(9.391f, 4.592f)
            lineTo(9.372f, 4.603f)
            lineTo(9.25f, 4.671f)
            lineTo(9.378f, 4.726f)
            lineTo(9.383f, 4.715f)
            lineTo(9.387f, 4.737f)
            lineTo(9.415f, 4.874f)
            lineTo(9.507f, 4.769f)
            lineTo(9.498f, 4.761f)
            lineTo(9.52f, 4.764f)
            lineTo(9.658f, 4.78f)
            lineTo(9.587f, 4.66f)
            lineTo(9.577f, 4.666f)
            lineTo(9.586f, 4.646f)
            lineTo(9.645f, 4.519f)
            lineTo(9.508f, 4.55f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFFFD500)),
            stroke = SolidColor(Color.Black),
            strokeLineWidth = 0.03f
        ) {
            moveTo(10.021f, 4.55f)
            lineTo(10.023f, 4.561f)
            lineTo(10.007f, 4.547f)
            lineTo(9.904f, 4.452f)
            lineTo(9.892f, 4.591f)
            lineTo(9.903f, 4.592f)
            lineTo(9.884f, 4.603f)
            lineTo(9.762f, 4.671f)
            lineTo(9.891f, 4.726f)
            lineTo(9.895f, 4.715f)
            lineTo(9.899f, 4.737f)
            lineTo(9.927f, 4.874f)
            lineTo(10.019f, 4.769f)
            lineTo(10.01f, 4.761f)
            lineTo(10.032f, 4.764f)
            lineTo(10.17f, 4.78f)
            lineTo(10.099f, 4.66f)
            lineTo(10.089f, 4.666f)
            lineTo(10.098f, 4.646f)
            lineTo(10.157f, 4.519f)
            lineTo(10.021f, 4.55f)
            close()
        }
        path(
            stroke = SolidColor(Color(0xFF373737)),
            strokeLineWidth = 0.06f
        ) {
            moveTo(7.71f, 5.15f)
            horizontalLineTo(9.698f)
            verticalLineTo(6.656f)
            curveTo(9.698f, 7.205f, 9.253f, 7.65f, 8.704f, 7.65f)
            curveTo(8.155f, 7.65f, 7.71f, 7.205f, 7.71f, 6.656f)
            verticalLineTo(5.15f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF6F3E1D)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(8.564f, 6.123f)
            curveTo(8.564f, 6.123f, 8.461f, 7.334f, 8.358f, 7.408f)
            curveTo(8.254f, 7.481f, 8.852f, 7.518f, 8.909f, 7.463f)
            curveTo(8.966f, 7.408f, 8.648f, 6.421f, 8.757f, 6.123f)
            curveTo(8.867f, 5.826f, 9.043f, 5.802f, 9.043f, 5.802f)
            curveTo(9.043f, 5.802f, 8.821f, 5.755f, 8.757f, 5.844f)
            curveTo(8.694f, 5.933f, 8.505f, 5.802f, 8.505f, 5.802f)
            lineTo(8.564f, 6.123f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF009D29)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(8.541f, 6.055f)
            horizontalLineTo(8.462f)
            curveTo(8.462f, 6.055f, 8.408f, 6.265f, 8.285f, 6.16f)
            curveTo(8.161f, 6.055f, 7.987f, 6.092f, 7.987f, 6.092f)
            curveTo(7.987f, 6.092f, 8.003f, 5.966f, 8.192f, 5.916f)
            curveTo(8.382f, 5.866f, 8.462f, 5.46f, 8.462f, 5.46f)
            curveTo(8.462f, 5.46f, 8.73f, 5.36f, 8.893f, 5.565f)
            curveTo(9.056f, 5.769f, 9.286f, 5.682f, 9.286f, 5.682f)
            curveTo(9.286f, 5.682f, 9.454f, 5.777f, 9.37f, 5.916f)
            curveTo(9.286f, 6.055f, 9.143f, 6.157f, 9.018f, 6.055f)
            curveTo(8.893f, 5.953f, 8.541f, 6.055f, 8.541f, 6.055f)
            close()
        }
    }.build()
}

@Preview
@Composable
private fun EquatorialGuineaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Small.EquatorialGuinea,
            contentDescription = "Equatorial Guinea Flag"
        )
    }
}
